import ky, { HTTPError } from 'ky'

const getApiBaseUrl = () => {
    // Если переменная окружения задана, используем её
    if (import.meta.env.VITE_API_URL) {
        return import.meta.env.VITE_API_URL
    }

    // Fallback: определяем URL на основе режима
    if (import.meta.env.DEV) {
        // В режиме разработки используем прокси
        return ''
    } else {
        // В продакшн используем полный URL
        return 'http://5.129.207.119:3000/'
    }
}

const createApiClient = () => {
    return ky.extend({
        prefixUrl: getApiBaseUrl(),
        headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
        },
        hooks: {
            beforeRequest: [
                (request) => {
                    const token = JSON.parse(localStorage.getItem('token') || '""')
                    if (token) {
                        request.headers.append('Authorization', `Bearer ${token}`)
                    }
                },
            ],
            afterResponse: [
                async (_1, _2, response) => {
                    const responseClone = response.clone()

                    // Check if response has content before trying to parse JSON
                    const text = await responseClone.text()
                    if (!text) {
                        throw new Error('Сервер вернул пустой ответ')
                    }

                    let jsonResponse
                    try {
                        jsonResponse = JSON.parse(text)
                    } catch (error) {
                        throw new Error('Сервер вернул некорректный JSON')
                    }
                    if (jsonResponse.success === false) {
                        if (jsonResponse.noauth) {
                            console.warn('Clear token')
                        }
                        throw new HTTPError(response, _1, _2)
                    }
                    return response
                },
            ],
        },
    })
}

export const apiClient = createApiClient()
